import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function login_saml(login_data, user_data) {
    var user_info = {"username": login_data.username};
    // setting username for the user that is needed in all apis
    window.localStorage.setItem("user_info", JSON.stringify(user_info));
    let data = user_data;
    appendTokenName(data);
    return apiAction({
        types: ["SAML_LOGIN_REQUESTED", "SAML_LOGIN_SUCCESS", "SAML_LOGIN_FAILED"],
        method: "POST",
        credentials: "same-origin",
        path: "login_saml/",
        body: data
    });
}


// WEBPACK FOOTER //
// ./src/actions/actionSSO.js